module.exports = "<app-tour-selector\n  [side]=\"Side.Left\"\n  (selectTour)=\"onSelectTour($event)\"\n  [requiresPanorama]=\"false\">\n</app-tour-selector>\n"